package domain.pieces

enum class TRSKicks(
    val cw: List<List<Pair<Int, Int>>>,
    val ccw: List<List<Pair<Int, Int>>>,
    val _180: List<List<Pair<Int, Int>>>,
) {

    I3(
        cw = listOf(
            listOf(0 to 0, -1 to 0, -1 to 1, 1 to -1, -1 to -1),   // 0→1
            listOf(0 to 0, 1 to 0, -1 to 0, 1 to 1, -1 to -1),    // 1→2
            listOf(0 to 0, 1 to 0, -1 to 0, 1 to 1, -1 to -1),    // 2→3 (== 1→0)
            listOf(0 to 0, 1 to 0, -1 to 0, 1 to 1, -1 to -1),    // 3→0 (== 1→0)
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, 1 to 1, -1 to -1, 1 to -1),     // 0→3
            listOf(0 to 0, -1 to 0, 1 to 0, -1 to 1, 1 to -1),    // 1→0
            listOf(0 to 0, -1 to 0, 1 to 0, -1 to 1, 1 to -1),    // 2→1 (== 1→0)
            listOf(0 to 0, -1 to 0, 1 to 0, -1 to 1, 1 to -1),    // 3→2 (== 1→0)
        ),
        _180 = listOf() // centrosymmetric: no 180° kicks
    ),

    C(
        cw = listOf(
            listOf(0 to 0, -1 to 0, 1 to 0),                                   // 0→1
            listOf(0 to 0, 0 to -1, 0 to 1),                                   // 1→2
            listOf(0 to 0, -1 to 0, 1 to 0),                                   // 2→3 (= 3→2 reversed)
            listOf(0 to 0, 0 to -1, 0 to 1),                                   // 3→0 (= 0→3 reversed)
        ),
        ccw = listOf(
            listOf(0 to 0, 0 to -1, 0 to 1),                                   // 0→3
            listOf(0 to 0, 1 to 0, -1 to 0),                                   // 1→0
            listOf(0 to 0, 0 to 1, 0 to -1),                                   // 2→1
            listOf(0 to 0, -1 to 0, 1 to 0),                                   // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 1),                       // 0→2
            listOf(0 to 0, 0 to 1, -1 to 1, 1 to 1),                       // 1→3
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to -1),                          // 2→0
            listOf(0 to 0, 0 to -1, 1 to -1, -1 to -1),                          // 3→1
        )
    ),

    STANDARD(
        cw = listOf(
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 2, -1 to 2),  // 0→1
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -2, 1 to -2), // 1→2
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 2, 1 to 2), // 2→3
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -2, -1 to -2), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 2, 1 to 2), // 0→3
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -2, 1 to -2), // 1→0
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 2, -1 to 2), // 2→1
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -2, -1 to -2), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 1, -1 to 0, 1 to 0), // 0→2
            listOf(0 to 0, 1 to 0, 1 to 2, 0 to 2, 1 to 1, 0 to 1),   // 1→3
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to -1, 1 to 0, -1 to 0), // 2→0
            listOf(0 to 0, -1 to 0, -1 to 2, 0 to 2, -1 to 1, 0 to 1)    // 3→1
        )
    ),

    I(
        cw = listOf(
            listOf(0 to 0, -2 to 0, 1 to 0, -2 to -1, 1 to 2),  // 0→1
            listOf(0 to 0, -1 to 0, 2 to 0, -1 to 2, 2 to -1),  // 1→2
            listOf(0 to 0, 2 to 0, -1 to 0, 2 to 1, -1 to -2),  // 2→3
            listOf(0 to 0, 1 to 0, -2 to 0, 1 to -2, -2 to 1)   // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 2 to 0, -1 to 0, 2 to 1, -1 to -2), // 0→3
            listOf(0 to 0, -1 to 0, 2 to 0, -1 to 2, 2 to -1), // 1→0
            listOf(0 to 0, -2 to 0, 1 to 0, -2 to -1, 1 to 2), // 2→1
            listOf(0 to 0, 1 to 0, -2 to 0, 1 to -2, -2 to 1), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, 0 to 2, 0 to -1, 0 to -2),   // 0→2
            listOf(0 to 0, 1 to 0, 2 to 0, -1 to 0, -2 to 0),   // 1→3
            listOf(0 to 0, 0 to -1, 0 to -2, 0 to 1, 0 to 2),   // 2→0
            listOf(0 to 0, -1 to 0, -2 to 0, 1 to 0, 2 to 0)    // 3→1
        )
    ),

    Z5(
        cw = listOf(
            listOf(0 to 0, 0 to -1, 1 to -1, -1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, -1 to -2),  // 0→1
            listOf(0 to 0, 0 to 1, -1 to 1, 1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, 1 to 2), // 1→2
            listOf(0 to 0, 0 to -1, 1 to -1, -1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, -1 to -2),   // 2→3 (== 0→1, centrosymmetric)
            listOf(0 to 0, 1 to 0, 0 to 3, 0 to 1, 0 to -1, 0 to 2, 0 to -2, 0 to -3, 1 to -2),    // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, 0 to 3, 0 to 1, 0 to -1, 0 to 2, 0 to -2, 0 to -3, 1 to -2),    // 0→3
            listOf(0 to 0, 0 to 1, -1 to 1, 1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, 1 to 2), // 1→0
            listOf(0 to 0, 1 to 0, 0 to 3, 0 to 1, 0 to -1, 0 to 2, 0 to -2, 0 to -3, 1 to -2),    // 2→1 (== 0→3, centrosymmetric)
            listOf(0 to 0, 0 to 1, -1 to 1, 1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, 1 to 2), // 3→2 (== 1→0, centrosymmetric)
        ),
        _180 = listOf()
    ),


    S5(
        cw = listOf(
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, 1 to -2),    // 0→1
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, -1 to 2), // 1→2
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, 1 to -2),    // 2→3 (== 0→1, centrosymmetric)
            listOf(0 to 0, -1 to 0, 0 to 3, 0 to 1, 0 to -1, 0 to 2, 0 to -2, 0 to -3, -1 to -2),  // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, -1 to 0, 0 to 3, 0 to 1, 0 to -1, 0 to 2, 0 to -2, 0 to -3, -1 to -2),  // 0→3
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, -1 to 2), // 1→0
            listOf(0 to 0, -1 to 0, 0 to 3, 0 to 1, 0 to -1, 0 to 2, 0 to -2, 0 to -3, -1 to -2),  // 2→1 (== 0→3, centrosymmetric)
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 0, 0 to 3, 0 to -2, 0 to 2, 0 to -3, -1 to 2), // 3→2 (== 1→0, centrosymmetric)
        ),
        _180 = listOf()
    ),

    P(
        cw = listOf(
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 2, -1 to 2, -1 to 1, 0 to -1),    // 0→1
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -2, 1 to -2, 1 to -1),                   // 1→2
            listOf(0 to 0, -1 to 0, -1 to 1, -1 to -1, 0 to 1, 0 to -2, -1 to -2),     // 2→3
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 2, 1 to 2),                          // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 2, 1 to 2),                          // 0→3
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -2, 1 to -2, 0 to 1, 1 to -1),         // 1→0
            listOf(0 to 0, -1 to 0, -1 to 1, -1 to -1, 0 to 2, -1 to 2),            // 2→1  (drop doc dupe)
            listOf(0 to 0, -1 to 0, -1 to 1, -1 to -1, 0 to 1, 0 to -2, -1 to -2),    // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, -1 to 0, 0 to 1, 0 to -1),                                  // 0→2
            listOf(0 to 0, 1 to 0, 0 to -1, -1 to 0),                                   // 1→3
            listOf(0 to 0, 1 to 0, 0 to -1, 0 to 1),                                   // 2→0
            listOf(0 to 0, -1 to 0, 0 to 1, 1 to 0),                                  // 3→1
        )
    ),

    Q(
        cw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 2, 1 to 2, 1 to 1, 0 to -1),        // 0→1
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -2, -1 to -2, -1 to -1),              // 1→2
            listOf(0 to 0, 1 to 0, 1 to 1, 1 to -1, 0 to 1, 0 to -2, 1 to -2),         // 2→3
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 2, -1 to 2),                       // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 2, -1 to 2),                       // 0→3
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -2, -1 to -2, 0 to 1, -1 to -1),     // 1→0
            listOf(0 to 0, 1 to 0, 1 to 1, 1 to -1, 0 to 2, 1 to 2),                // 2→1  (drop doc dupe)
            listOf(0 to 0, -1 to 0, -1 to -1, 1 to 0, 0 to 2, -1 to 2),              // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 1 to 0, 0 to 1, 0 to -1),                                   // 0→2
            listOf(0 to 0, -1 to 0, 0 to -1, 1 to 0),                                   // 1→3
            listOf(0 to 0, -1 to 0, 0 to -1, 0 to 1),                                  // 2→0
            listOf(0 to 0, 1 to 0, 0 to 1, -1 to 0),                                  // 3→1
        )
    ),

    F(
        cw = listOf(
            listOf(0 to 0, -1 to 0, 1 to 0, -1 to -1, 0 to 2, 0 to 3),               // 0→1
            listOf(0 to 0, 1 to 0, 0 to 1, -1 to 0, 0 to -2),                          // 1→2
            listOf(0 to 0, -1 to 0, 0 to -1, -1 to -1, 1 to 0, 0 to -2, -2 to 0),        // 2→3
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -1, 0 to 2, 0 to 3),                // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -1, 0 to 2, 0 to 3),                // 0→3
            listOf(0 to 0, 1 to 0, 1 to 1, -1 to 0, 0 to -2, 0 to -3),                 // 1→0
            listOf(0 to 0, -1 to 0, 0 to -1, 1 to 0, 0 to 2),                         // 2→1
            listOf(0 to 0, -1 to -1, 1 to 0, 0 to 1, 0 to -2, 0 to -3),                 // 3→0 — doc 3→0
        ),
        _180 = listOf(
            listOf(0 to 0, 1 to 0, -1 to 0, -1 to 1),                                 // 0→2
            listOf(0 to 0, 0 to 1, -1 to -1, 0 to -1),                                  // 1→3
            listOf(0 to 0, -1 to 0, 1 to 0, 1 to -1),                                   // 2→0
            listOf(0 to 0, 0 to 1, 1 to 1, 0 to -1),                                  // 3→1
        )
    ),

    E(
        cw = listOf(
            listOf(0 to 0, 1 to 0, -1 to 0, 1 to -1, 0 to 2, 0 to 3),                // 0→1
            listOf(0 to 0, -1 to 0, 0 to 1, 1 to 0, 0 to -2),                          // 1→2
            listOf(0 to 0, 1 to 0, 0 to -1, 1 to -1, -1 to 0, 0 to -2, 2 to 0),          // 2→3
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -1, 0 to 2, 0 to 3),              // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -1, 0 to 2, 0 to 3),              // 0→3
            listOf(0 to 0, -1 to 0, -1 to 1, 1 to 0, 0 to -2, 0 to -3),                // 1→0
            listOf(0 to 0, 1 to 0, 0 to -1, -1 to 0, 0 to 2),                         // 2→1
            listOf(0 to 0, 1 to -1, -1 to 0, 0 to 1, 0 to -2, 0 to -3),                 // 3→0 — doc 3→0
        ),
        _180 = listOf(
            listOf(0 to 0, -1 to 0, 1 to 0, 1 to 1),                                  // 0→2
            listOf(0 to 0, 0 to 1, 1 to -1, 0 to -1),                                   // 1→3
            listOf(0 to 0, 1 to 0, -1 to 0, -1 to -1),                                  // 2→0
            listOf(0 to 0, 0 to 1, -1 to 1, 0 to -1),                                 // 3→1
        )
    ),

    T5(
        cw = listOf(
            listOf(0 to 0, 0 to 1, -1 to 1, 1 to 0, 1 to -1, 0 to 3, -1 to 0, 0 to -2, -1 to -2),  // 0→1
            listOf(0 to 0, 1 to 0, -1 to 0, 0 to 2, 0 to 3, 0 to -1, -1 to -1),                     // 1→2
            listOf(0 to 0, -1 to 0, 1 to 0, 0 to 2, 0 to 3, 0 to -1, 1 to -1),                      // 2→3
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 0, -1 to -1, 0 to 3, 1 to 0, 0 to -2, 1 to -2),   // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 0, -1 to -1, 0 to 3, 1 to 0, 0 to -2, 1 to -2),   // 0→3
            listOf(0 to 0, 1 to 0, 0 to 1, -1 to 1, 0 to 2, -1 to -1, 0 to 3, 1 to 2, 0 to -1), // 1→0
            listOf(0 to 0, 1 to 1, -1 to 0, 1 to 0, 0 to 1, 0 to -2, 0 to -3),                     // 2→1
            listOf(0 to 0, -1 to 0, 0 to 1, 1 to 1, 0 to 2, 1 to -1, 0 to 3, -1 to 2, 0 to -1), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, 0 to -1, 0 to -2),                                                // 0→2
            listOf(0 to 0, 1 to 0, -1 to -1, -2 to 0),                                               // 1→3
            listOf(0 to 0, 0 to 1, 0 to -1, 0 to 2),                                               // 2→0
            listOf(0 to 0, -1 to 0, 1 to -1, 2 to 0),                                                // 3→1
        )
    ),
    U(
        cw = listOf(
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 2, -1 to 2),                       // 0→1
            listOf(0 to 0, 1 to 0, 1 to 1, 1 to -1),                                    // 1→2
            listOf(0 to 0, -1 to 0, -1 to 1, -1 to -1),                                 // 2→3
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 2, 1 to 2),                          // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 2, 1 to 2),                          // 0→3
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -2, 1 to -2),                           // 1→0
            listOf(0 to 0, -1 to 1, -1 to -1, -1 to 0),                                 // 2→1  (deduped)
            listOf(0 to 0, 1 to 1, 1 to -1, 1 to 0),                                    // 3→2  (deduped)
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to -1),                                                      // 0→2
            listOf(0 to 0, 0 to 1, 0 to -1, 1 to 0),                                   // 1→3
            listOf(0 to 0, 0 to 1),                                                     // 2→0
            listOf(0 to 0, 0 to 1, 0 to -1, -1 to 0),                                  // 3→1
        )
    ),

    V(
        cw = listOf(
            listOf(0 to 0, 0 to -1, -1 to 0, 0 to 2, -1 to 2),                        // 0→1
            listOf(0 to 0, 0 to 1, 0 to -1, 0 to -2),                                    // 1→2
            listOf(0 to 0, -1 to 0, 1 to 0),                                             // 2→3
            listOf(0 to 0, 0 to 1, 0 to -1, 0 to 2),                                   // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 0 to 1, 0 to -1, 0 to -2),                                    // 0→3
            listOf(0 to 0, 0 to -1, 1 to 0, 0 to 2, 1 to 2),                           // 1→0
            listOf(0 to 0, 0 to 1, 0 to -1, 0 to 2),                                   // 2→1
            listOf(0 to 0, 1 to 0, -1 to 0),                                             // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, -1 to -1, 1 to 1),                                            // 0→2
            listOf(0 to 0, 1 to -1, -1 to 1),                                            // 1→3
            listOf(0 to 0, 1 to 1, -1 to -1),                                            // 2→0
            listOf(0 to 0, -1 to 1, 1 to -1),                                            // 3→1
        )
    ),

    W(
        cw = listOf(
            listOf(0 to 0, 0 to 1, -1 to 0, 1 to 0, 1 to 1, 0 to -2),                 // 0→1
            listOf(0 to 0, 1 to 0, 0 to 1, -2 to 0, 1 to -1, -1 to 0, 0 to -1, -1 to 1), // 1→2
            listOf(0 to 0, 0 to 1, 1 to 1, 0 to -1, 0 to 2, -1 to 2, 0 to -2),       // 2→3
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 1, 0 to 2, 0 to 3, -1 to 1, 0 to -1, 0 to -2, 0 to -3), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 1, 0 to 2, 0 to 3, 1 to 1, 0 to -1, 0 to -2, 0 to -3), // 0→3
            listOf(0 to 0, 0 to 1, -1 to 1, 0 to -1, 0 to 2, 1 to 2, 0 to -2),       // 1→0
            listOf(0 to 0, -1 to 0, 0 to 1, 2 to 0, -1 to -1, 1 to 0, 0 to -1, 1 to 1), // 2→1
            listOf(0 to 0, 0 to 1, 1 to 0, 0 to -1, -1 to 0, -1 to 1, 0 to -2),        // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, -1 to 0),                                            // 0→2
            listOf(0 to 0, 0 to -1, -1 to 0),                                             // 1→3
            listOf(0 to 0, 0 to -1, 1 to 0),                                              // 2→0
            listOf(0 to 0, 0 to 1, 1 to 0),                                             // 3→1
        )
    ),

    J5(
        cw = listOf(
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 3, -1 to -2, 0 to -1),               // 0→1  (deduped test 5)
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to 1, 1 to 2, 0 to 2, 1 to -1, -1 to 0, 0 to -2, 1 to -2), // 1→2
            listOf(0 to 0, -1 to 0, -1 to -1, -1 to 1, 1 to 0, 0 to -2, -1 to -2, 0 to 2), // 2→3
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to 0, -1 to 1, 0 to -2, -1 to -2, 0 to -3, -1 to -3, 1 to 1), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to 0, -1 to 1, 0 to -2, -1 to -2, 0 to -3, -1 to -3, 1 to 1), // 0→3
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to -1, -1 to -2, 0 to -2, -1 to 1, 1 to 0, 0 to 2, -1 to 2), // 1→0
            listOf(0 to 0, -1 to 0, 1 to 1, 0 to -3, 1 to 2, 0 to -1),                 // 2→1  (deduped test 5)
            listOf(0 to 0, 1 to 0, 1 to 1, 1 to -1, -1 to 0, 0 to 2, 1 to 2, 0 to -2), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, -1 to 1, 1 to 1, -1 to 0, 2 to 1),              // 0→2
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -1, -1 to 2),                        // 1→3
            listOf(0 to 0, 0 to -1, 1 to -1, -1 to -1, 1 to 0, -2 to -1),                  // 2→0
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 1, 1 to -2),                           // 3→1
        )
    ),

    L5(
        cw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 3, 1 to -2, 0 to -1),                  // 0→1  (deduped test 5)
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to 1, -1 to 2, 0 to 2, -1 to -1, 1 to 0, 0 to -2, -1 to -2), // 1→2
            listOf(0 to 0, 1 to 0, 1 to -1, 1 to 1, -1 to 0, 0 to -2, 1 to -2, 0 to 2), // 2→3
            listOf(0 to 0, 0 to -1, 1 to -1, -1 to 0, 1 to 1, 0 to -2, 1 to -2, 0 to -3, 1 to -3, -1 to 1), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 0 to -1, 1 to -1, -1 to 0, 1 to 1, 0 to -2, 1 to -2, 0 to -3, 1 to -3, -1 to 1), // 0→3
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to -1, 1 to -2, 0 to -2, 1 to 1, -1 to 0, 0 to 2, 1 to 2), // 1→0
            listOf(0 to 0, 1 to 0, -1 to 1, 0 to -3, -1 to 2, 0 to -1),                // 2→1  (deduped test 5)
            listOf(0 to 0, -1 to 0, -1 to 1, -1 to -1, 1 to 0, 0 to 2, -1 to 2, 0 to -2), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 1, 1 to 0, -2 to 1),              // 0→2
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -1, 1 to 2),                          // 1→3
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to -1, -1 to 0, 2 to -1),                  // 2→0
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 1, -1 to -2),                        // 3→1
        )
    ),

    R(
        cw = listOf(
            listOf(0 to 0, -1 to 0, -1 to -1, 1 to 0, -1 to -2, -1 to 1, 0 to 3, 0 to -1), // 0→1
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to 1, 1 to 2, 0 to 2, 1 to -1, -1 to 0, 0 to -2, 1 to -2), // 1→2
            listOf(0 to 0, 0 to 1, -1 to 0, -1 to -1, -1 to 1, 1 to 0, 0 to -2, -1 to -2, 0 to 2), // 2→3
            listOf(0 to 0, 0 to 1, -1 to 0, 0 to -1, -1 to -1, 1 to 0, -1 to 1, 0 to -2, -1 to -2, 0 to -3, -1 to -3, 1 to 1), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 0 to 1, 1 to 0, 0 to -1, 1 to 1, -1 to 0, 1 to -1, 0 to 2, 1 to 2, 0 to 3, 1 to 3, -1 to -1), // 0→3
            listOf(0 to 0, -1 to 0, 1 to 0, 1 to 1, 1 to 2, 1 to -1, 0 to -3, 0 to -1),  // 1→0
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to -1, -1 to -2, 0 to -2, -1 to 1, 1 to 0, 0 to 2, -1 to 2), // 2→1
            listOf(0 to 0, 0 to -1, 1 to 0, 1 to 1, 1 to -1, -1 to 0, 0 to 2, 1 to 2, 0 to -2), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, 1 to 1, -1 to 0, 2 to 1, 0 to -1),                // 0→2
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -1, -1 to 2),                        // 1→3
            listOf(0 to 0, 0 to -1, -1 to -1, 1 to 0, -2 to -1, 0 to 1),                 // 2→0
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 1, 1 to -2),                           // 3→1
        )
    ),

    Y(
        cw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, -1 to 0, 1 to -2, 1 to 1, 0 to 3, 0 to -1), // 0→1
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to 1, -1 to 2, 0 to 2, -1 to -1, 1 to 0, 0 to -2, -1 to -2), // 1→2
            listOf(0 to 0, 0 to 1, 1 to 0, 1 to -1, 1 to 1, -1 to 0, 0 to -2, 1 to -2, 0 to 2), // 2→3
            listOf(0 to 0, 0 to 1, -1 to 0, 0 to -1, -1 to 1, 1 to 0, -1 to -1, 0 to 2, -1 to 2, 0 to 3, -1 to 3, 1 to -1), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 0 to 1, -1 to 0, 0 to -1, -1 to 1, 1 to 0, -1 to -1, 0 to 2, -1 to 2, 0 to 3, -1 to 3, 1 to -1), // 0→3
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to -1, 1 to -2, 0 to -2, 1 to 1, -1 to 0, 0 to 2, 1 to 2), // 1→0
            listOf(0 to 0, 0 to -1, -1 to 0, -1 to 1, -1 to -1, 1 to 0, 0 to 2, -1 to 2, 0 to -2), // 2→1
            listOf(0 to 0, 0 to 1, 1 to 0, 1 to -1, 1 to 1, -1 to 0, 0 to -2, 1 to -2, 0 to 2), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 0 to 1, -1 to 1, 1 to 0, -2 to 1, 0 to -1),               // 0→2
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -1, 1 to 2),                          // 1→3
            listOf(0 to 0, 0 to -1, 1 to -1, -1 to 0, 2 to -1, 0 to 1),                  // 2→0
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 1, -1 to -2),                        // 3→1
        )
    ),

    N(
        cw = listOf(
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to -1, 1 to 0, 1 to -1, -1 to -2, -2 to 0, 0 to 2), // 0→1
            listOf(0 to 0, -1 to 0, 1 to 1, -1 to 1, 1 to 2, 1 to 0, 0 to 2, 1 to 3, -1 to -2, 0 to -3, -1 to -3), // 1→2
            listOf(0 to 0, 0 to 2, 0 to 3, 1 to -2, 1 to 0, 0 to -1, -1 to -1, 0 to 1, 0 to -2), // 2→3
            listOf(0 to 0, -1 to 0, 1 to 1, 0 to 2, 0 to 3, 1 to 0, 1 to 2, 1 to 3, 0 to -1, -1 to -1), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, -1 to 0, 1 to 1, 0 to 2, 0 to 3, 1 to 0, 1 to 2, 1 to 3, 0 to -1, -1 to -1), // 0→3
            listOf(0 to 0, -1 to 0, 0 to 1, -1 to 2, 1 to 1, 1 to 0, 1 to -1, 0 to -2, 0 to -3), // 1→0
            listOf(0 to 0, -1 to 0, 1 to 1, -1 to 1, 1 to 2, 1 to 0, 0 to 2, 1 to 3, -1 to -2, 0 to -3, -1 to -3), // 2→1
            listOf(0 to 0, -1 to 0, 1 to 1, 1 to -1, 0 to 2, 0 to 3, 1 to 0, 1 to 2, 1 to 3, 0 to -1, -1 to -1), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, -1 to 0, 0 to -2, 0 to 1),                                  // 0→2
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to -1, 1 to -2),                         // 1→3
            listOf(0 to 0, 1 to 0, 0 to 2, 0 to -1),                                   // 2→0
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to 1, -1 to 2),                         // 3→1
        )
    ),

    H(
        cw = listOf(
            listOf(0 to 0, 1 to 0, 1 to -1, 0 to -1, -1 to 0, -1 to -1, 1 to -2, 2 to 0, 0 to 2), // 0→1
            listOf(0 to 0, 1 to 0, -1 to 1, 1 to 1, -1 to 2, -1 to 0, 0 to 2, -1 to 3, 1 to -2, 0 to -3, 1 to -3), // 1→2
            listOf(0 to 0, 0 to 2, 0 to 3, -1 to -2, -1 to 0, 0 to -1, 1 to -1, 0 to 1, 0 to -2), // 2→3
            listOf(0 to 0, 1 to 0, -1 to 1, 0 to 2, 0 to 3, -1 to 0, -1 to 2, -1 to 3, 0 to -1, 1 to -1), // 3→0
        ),
        ccw = listOf(
            listOf(0 to 0, 1 to 0, -1 to 1, 0 to 2, 0 to 3, -1 to 0, -1 to 2, -1 to 3, 0 to -1, 1 to -1), // 0→3
            listOf(0 to 0, -1 to 0, 1 to 0, 0 to 1, 1 to 1, -1 to 1, -1 to 2, -2 to 0, 0 to -2), // 1→0
            listOf(0 to 0, 1 to 0, -1 to 1, -1 to -1, 0 to 2, 0 to 3, -1 to 0, -1 to 2, -1 to 3, 0 to -1, 1 to -1), // 2→1
            listOf(0 to 0, 1 to 0, 0 to 1, 1 to 2, -1 to 1, -1 to 0, -1 to -1, 0 to -2, 0 to -3), // 3→2
        ),
        _180 = listOf(
            listOf(0 to 0, 1 to 0, 0 to -2, 0 to 1),                                   // 0→2
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to -1, -1 to -2),                          // 1→3
            listOf(0 to 0, -1 to 0, 0 to 2, 0 to -1),                                  // 2→0
            listOf(0 to 0, -1 to 0, -1 to -1, 0 to 1, 1 to 2),                        // 3→1
        )
    ),

    I5(
        cw = listOf(
            // 0→1
            listOf(0 to 0, 1 to 1, 1 to 0, 1 to -1, 0 to -1, -1 to -1, -1 to 0, -1 to 1, 0 to 1, 0 to 2, -2 to 1, -2 to 2, 2 to 0, 2 to 1, 2 to 2, 1 to -2, 2 to -2, -1 to -2, -2 to -2),
            // 1→2
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to 1, -1 to 1, 2 to 2, 2 to 1, 2 to 0, 1 to 2, 0 to 2, -1 to 2, -2 to 2, 1 to -1, 2 to -1, 2 to -2, -1 to 0, -2 to 0, -2 to 1, 0 to -1, -1 to 1, -2 to 2),
            // 2→3 (== 0→1 for centrosymmetric)
            listOf(0 to 0, 1 to 1, 1 to 0, 1 to -1, 0 to -1, -1 to -1, -1 to 0, -1 to 1, 0 to 1, 0 to 2, -2 to 1, -2 to 2, 2 to 0, 2 to 1, 2 to 2, 1 to -2, 2 to -2, -1 to -2, -2 to -2),
            // 3→0 (== 1→2 for centrosymmetric)
            listOf(0 to 0, 1 to 0, 1 to 1, 0 to 1, -1 to 1, 2 to 2, 2 to 1, 2 to 0, 1 to 2, 0 to 2, -1 to 2, -2 to 2, 1 to -1, 2 to -1, 2 to -2, -1 to 0, -2 to 0, -2 to 1, 0 to -1, -1 to 1, -2 to 2),
        ),
        ccw = listOf(
            // 0→3
            listOf(0 to 0, -1 to 1, -1 to 0, -1 to -1, 0 to -1, 1 to -1, 1 to 0, 1 to 1, 0 to 1, 0 to 2, 2 to 1, 2 to 2, -2 to 0, -2 to 1, -2 to 2, -1 to -2, -2 to -2, 1 to -2, 2 to -2),
            // 1→0
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to 1, 1 to 1, -2 to 2, -2 to 1, -2 to 0, -1 to 2, 0 to 2, 1 to 2, 2 to 2, -1 to -1, -2 to -1, -2 to -2, 1 to 0, 2 to 0, 2 to 1, 0 to -1, 1 to 1, 2 to 2),
            // 2→1 (== 0→3)
            listOf(0 to 0, -1 to 1, -1 to 0, -1 to -1, 0 to -1, 1 to -1, 1 to 0, 1 to 1, 0 to 1, 0 to 2, 2 to 1, 2 to 2, -2 to 0, -2 to 1, -2 to 2, -1 to -2, -2 to -2, 1 to -2, 2 to -2),
            // 3→2 (== 1→0)
            listOf(0 to 0, -1 to 0, -1 to 1, 0 to 1, 1 to 1, -2 to 2, -2 to 1, -2 to 0, -1 to 2, 0 to 2, 1 to 2, 2 to 2, -1 to -1, -2 to -1, -2 to -2, 1 to 0, 2 to 0, 2 to 1, 0 to -1, 1 to 1, 2 to 2),
        ),
        _180 = listOf() // centrosymmetric: no 180° kicks
    ),
}